
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSetToExercise, editSetValue, removeSetFromExercise } from '../../store';
import NoteModal from '../modals/NoteModal';

const WorkoutExerciseConfig = ({ workoutId, exercise, onUpdateSet, onRemoveSet }) => {
  const dispatch = useDispatch();
  const { program } = useSelector((state) => { //estado que guarda el objeto grande
    return {program: state.program.data};
  });
  const maxSetNumber = program.workouts.flatMap(w => w.exercises).filter(e => e.key === exercise.key).reduce((max, e) => Math.max(max, e.sets.length), 0)
  const InputCell = ({ value, onChange, placeholder = '', width = 'w-14' }) => (
    <input
      type="text"
      defaultValue={value}
      onBlur={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`${width} px-1 py-0.5 text-xs text-center border border-gray-200 rounded 
        focus:border-blue-500 focus:ring-1 focus:ring-blue-100 focus:outline-none
        hover:border-gray-300 transition-all duration-150`}
    />
  );

  const [globalConfig, setGlobalConfig] = useState({ 
    kg: '',
    time: '',
    reps: '',
    rpe: '',
    rir: '',
    tut: '',
    percentage_rm: '',
    rest: ''
  });


  const handleGlobalChange = (field, value) => {
    setGlobalConfig(prev => ({ ...prev, [field]: value }));
    // Apply to all sets if they're empty
    exercise.sets.forEach((set) => dispatch(editSetValue({setId:set.id,field,exerciseKey:exercise.key, workoutId, value})));
  };

  const handleSetChange = (setId, field, value) => {
    dispatch(editSetValue({setId, field, exerciseKey:exercise.key, workoutId, value}))
  };

  
  const onAddSet = (exerciseKey) =>{
    dispatch(addSetToExercise({workoutId, exerciseKey}))
  }
  const removeSet = (exerciseKey, setId) => {
      dispatch(removeSetFromExercise({workoutId, exerciseKey, setId}));
  };

  const [openModalSetNote, setOpenModalSetNote] = useState(false);
  const [modalSetNoteData, setModalSetNoteData] = useState('');
  const [modalSetKey, setModalSetKey] = useState('');
  const onAddNotes = (set) =>{
    setModalSetNoteData((set.note === null || set.note === undefined)? '': set.note);
    setModalSetKey(set.id);
    setOpenModalSetNote(true);
  }
  const onSaveSetNote = (setId,note) =>{
    dispatch(editSetValue({setId, field:"note", exerciseKey:exercise.key, workoutId, value:note}))
    handleCloseModalSetNote();
  }
  const handleCloseModalSetNote = () => {
  setOpenModalSetNote(false);
  setModalSetNoteData('');  // Resetea el contenido
  setModalSetKey('');
  }
  

  return (
    <div className="overflow-x-auto">
        <table className="w-full">
          <caption className={`${exercise.superset ? generateColor(exercise.superset) :'bg-gray-50'} border-t border-gray-200  text-left`}>{exercise.name}</caption>
          <caption className="border-b border-gray-200 bg-gray-50  text-xs text-left">{exercise.note}</caption>
          <thead>
            <tr className="border-b border-gray-200 bg-gray-50">
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-left">Set</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">Kg</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">%RM</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">Time</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">Reps</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">Rest</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">RPE</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">RIR</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">TUT</th>
              <th className="px-2 py-1.5 text-xs font-medium text-gray-700 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* Global Configuration Row */}
            <tr className="bg-blue-50 border-b border-blue-100">
              <td className="px-2 py-1.5 text-xs font-medium text-blue-700 flex items-center gap-1">
                All sets
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.kg} 
                  onChange={(val) => handleGlobalChange('kg', val)}
                  placeholder="2.5"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell
                  value={globalConfig.percentage_rm}
                  onChange={(val) => handleGlobalChange('percentage_rm', val)}
                  placeholder="80"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.time} 
                  onChange={(val) => handleGlobalChange('time', val)}
                  placeholder="1&#39;30&#34;"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.reps} 
                  onChange={(val) => handleGlobalChange('reps', val)}
                  placeholder="10"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.rest} 
                  onChange={(val) => handleGlobalChange('rest', val)}
                  placeholder="1&#39;30&#34;"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.rpe} 
                  onChange={(val) => handleGlobalChange('rpe', val)}
                  placeholder="8"
                  width="w-12"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.rir} 
                  onChange={(val) => handleGlobalChange('rir', val)}
                  placeholder="3"
                  width="w-12"
                />
              </td>
              <td className="px-2 py-1.5 text-center">
                <InputCell 
                  value={globalConfig.tut} 
                  onChange={(val) => handleGlobalChange('tut', val)}
                  placeholder="XYZW"
                />
              </td>
              <td className="px-2 py-1.5">
                <div className="flex items-center justify-center gap-1">
                  <button
                    onClick={() => onAddSet(exercise.key)}
                    className="p-1 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded transition-all"
                    title="Add notes"
                  >
                    + Set
                  </button>
                </div>
              </td>
            </tr>

            {/* Individual Set Rows */}
            {exercise.sets.map((set, index) => (
              <tr key={set.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                <td className="px-2 py-1.5 text-xs font-medium text-gray-600">
                  Set {set.index}
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.kg} 
                    onChange={(val) => handleSetChange(set.id, 'kg', val)}
                    placeholder=""
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell
                    value={set.percentage_rm}
                    onChange={(val) => handleSetChange(set.id, 'percentage_rm', val)}
                    placeholder="%"
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.time} 
                    onChange={(val) => handleSetChange(set.id, 'time', val)}
                    placeholder=""
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.reps} 
                    onChange={(val) => handleSetChange(set.id, 'reps', val)}
                    placeholder=""
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.rest} 
                    onChange={(val) => handleSetChange(set.id, 'rest', val)}
                    placeholder=""
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.rpe} 
                    onChange={(val) => handleSetChange(set.id, 'rpe', val)}
                    placeholder=""
                    width="w-12"
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.rir} 
                    onChange={(val) => handleSetChange(set.id, 'rir', val)}
                    placeholder=""
                    width="w-12"
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <InputCell 
                    value={set.tut} 
                    onChange={(val) => handleSetChange(set.id, 'tut', val)}
                    placeholder=""
                  />
                </td>
                <td className="px-2 py-1.5">
                  <div className="flex items-center justify-center gap-1">
                    <button
                      onClick={() => onAddNotes && onAddNotes(set)}
                      className="p-1 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-all"
                      title="Add notes"
                    >
                      Notes
                    </button>
                    <button
                      onClick={() => removeSet(exercise.key,set.id)}
                      className="p-1 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-all"
                      title="Remove set"
                    >
                      X
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {/* Empty rows to have same height for exercises with less sets */}
            {Array.from({ length: Math.max(0, maxSetNumber - exercise.sets.length) }, (_, i) => (
              <tr key={`empty-${i}`} className="border-b border-gray-100">
                <td className="px-2 py-1.5 text-xs font-medium text-gray-400">
                  Set {exercise.sets.length + i + 1}
                </td>
                <td className="px-2 py-1.5"><div className="h-6">-</div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
                <td className="px-2 py-1.5"><div className="h-6"></div></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="10" className="p-0">
                <div className="h-1 bg-black w-full"></div>
              </td>
            </tr>
          </tfoot>
        </table>
        <NoteModal open={openModalSetNote} itemKey={modalSetKey} setOpen={setOpenModalSetNote} initialNote={modalSetNoteData} onSave={onSaveSetNote}/>
      </div>
  );
};

function generateColor(str) {
  // Generar un valor hash a partir del string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convertir el hash en un valor entre 0 y 255
  let value = hash & 0xFF;
  
  // Generar una clase de Tailwind basada en el valor
  let tailwindColors = [
      'bg-red-200', 
      'bg-orange-200', 
      'bg-amber-200', 
      'bg-yellow-200', 
      'bg-lime-200', 
      'bg-green-200',
      'bg-emerald-200', 
      'bg-teal-200',
      'bg-cyan-200',
      'bg-sky-200',
      'bg-blue-200', 
      'bg-indigo-200', 
      'bg-violet-200',
      'bg-purple-200', 
      'bg-fuchsia-200', 
      'bg-pink-200',
      'bg-rose-200',
      'bg-fuchsia-200',
  ];
  
  // Seleccionar una clase de color de Tailwind
  let tailwindClass = tailwindColors[value % tailwindColors.length];
  
  return tailwindClass;
}

export default WorkoutExerciseConfig;
